import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Account',
  viewProfile: 'Profiel bekijken',
  roles: {
    admin: 'Platformbeheerder',
    companyAdmin: 'Bedrijfsbeheerder',
    departmentAdmin: 'Afdelingsbeheerder/coach',
  },
  company: {
    label: 'Bedrijf',
    switchTo: 'Overschakelen naar {{name}}',
  },
  accounts: {
    label: 'Andere accounts',
    switchTo: 'Overschakelen naar {{name}}',
    addAnother: 'Inloggen met een ander account',
  },
  manage: 'Beheer',
  settings: 'Bedrijfsprofiel',
  language: 'Taal',
  theme: {
    label: 'Thema',
    light: 'Licht',
    dark: 'Donker',
    system: 'Systeem',
  },
  signOut: 'Uitloggen',
  signOutAll: 'Uitloggen bij alle accounts',
};
